import { motion } from "framer-motion";
import { FlaskConical, BookOpen, Cpu, ScanSearch } from "lucide-react";

const trustItems = [
  { icon: FlaskConical, text: "Scoring calibrated against visual attention research and eye-tracking data" },
  { icon: BookOpen, text: "Based on peer-reviewed neuroscience research" },
  { icon: Cpu, text: "Ad analysis powered by real-time computer vision and predictive AI" },
  { icon: ScanSearch, text: "Every analysis processes 7 computer vision signals in real time" },
];

export default function SocialProofSection() {
  return (
    <section className="py-24 bg-[#F8F9FC]" data-testid="social-proof-section">
      <div className="max-w-[1200px] mx-auto px-6">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.6 }}
          className="text-center mb-14"
        >
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight" style={{ fontFamily: 'Outfit, sans-serif', color: '#0F172A' }}>
            Built on <span className="gradient-text">Science</span>, Not Hype
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {trustItems.map((item, i) => (
            <motion.div
              key={i}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.5, delay: i * 0.08 }}
              data-testid={`trust-item-${i}`}
              className="bg-white rounded-2xl border border-slate-200 p-6 text-center hover:-translate-y-1 hover:shadow-lg transition-all duration-300"
            >
              <div className="w-12 h-12 rounded-xl bg-orange-50 flex items-center justify-center mx-auto mb-4">
                <item.icon size={22} className="text-orange-500" />
              </div>
              <p className="text-sm text-slate-600 leading-relaxed">{item.text}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
